import InputGroup from '../components/InputGroup';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const SeekerCount = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>구도자</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup
              title={'접촉중'} //
              value={reportMxData?.seekers_contact}
              setReportMxData={setReportMxData}
              reportColumnName={'seekers_contact'}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup
              title={'공부자'} //
              value={reportMxData?.seekers_study}
              setReportMxData={setReportMxData}
              reportColumnName={'seekers_study'}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup
              title={'침례반'} //
              value={reportMxData?.seekers_baptism}
              setReportMxData={setReportMxData}
              reportColumnName={'seekers_baptism'}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-xs-6 col-sm-3 col-md-3">
            <InputGroup
              title={'수침자'} //
              value={reportMxData?.baptism}
              setReportMxData={setReportMxData}
              reportColumnName={'baptism'}
              disabled={isReadOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeekerCount;
